module.exports = __webpack_public_path__ + "img/sunset.9c33dfb8.svg";